import { MenuItem, Text } from '@chakra-ui/react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { useAuthenticationStore } from '$/components/core/Authentication/stores/useAuthenticationStore';

interface Props {
  name: string;
  isMobile?: boolean;
}

export const ProMenuItem: FC<Props> = ({ name, isMobile = false }) => {
  const { t } = useTranslation();

  const { hasPermission } = useAuthorization();
  const openAuthenticationModal = useAuthenticationStore.useOnModalOpen();

  if (hasPermission('View_All_Collections')) {
    return null;
  }

  return (
    <MenuItem
      justifyContent='space-between'
      gap='3'
      px={isMobile ? '3' : undefined}
      py={isMobile ? '4' : undefined}
      fontWeight={isMobile ? 'bold' : undefined}
      onClick={() => openAuthenticationModal('versionComparison')}
    >
      <Text fontSize='sm'>
        {t('general.more')} {name}
      </Text>
      <Text
        px='1'
        color='reverseText'
        fontSize='xs'
        fontWeight='bold'
        bg='primaryButton.background'
        borderRadius='2px'
      >
        {t('roles.proLabel')}
      </Text>
    </MenuItem>
  );
};
